import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  Platform,
  TouchableOpacity,
  Image,
} from "react-native";

import { escapeRegexp } from "../../../../helpers/utils";
import AppTheme from "../../AppTheme";
import AutocompleteView from "../../common/autocomplete/AutocompleteView";
import ALL_COUNTRIES from "./countries";

export default function CountrySelector({
  data,
  slide,
  changeScreen = () => {},
  updateInfo = () => {},
}) {
  const [countries, setCountries] = useState([]);

  const onChangeText = (text) => {
    if (text == data.country) return;

    let filteredCountries = [...ALL_COUNTRIES];
    if (text) {
      const pattern = new RegExp(escapeRegexp(text).split(" ").join("|"), "gi");
      filteredCountries = filteredCountries.filter((a) => {
        return a.name && a.name.match(pattern);
      });
    }

    setCountries(filteredCountries);
  };

  const onOptionPress = (opt) => {
    // Close dropdown
    setCountries([]);
    updateInfo("country", opt.name);
  };

  const toggleList = (isCollapsed) => {
    setCountries(isCollapsed ? [] : [...ALL_COUNTRIES]);
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Where are you based?</Text>
      <AutocompleteView
        onOptionPress={(opt) => onOptionPress(opt)}
        onChangeText={onChangeText}
        onIconPressed={toggleList}
        options={countries}
        optionsListHeight={100}
        value={data.country || ""}
      />

      {/* Image */}
      <TouchableOpacity
        onPress={() => changeScreen(1)}
        style={[styles.imageContainer]}
      >
        <Image style={styles.image} source={slide.image} resizeMode="contain" />
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    minHeight: 220,
    paddingTop: 30,
  },
  title: {
    zIndex: 10,
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "600",
    fontSize: 20,
    lineHeight: 30,
    letterSpacing: 1,
    color: AppTheme.almostBlack,
  },
  imageContainer: {
    width: 400,
    maxWidth: "100%",
    maxHeight: 300,
    display: "flex",
    alignItems: "center",
    marginBottom: 40,
  },
  image: {
    width: "80%",
    maxHeight: "100%",
  },
});
